import React from "react";
import styled from "styled-components";
import AdaptiveMenuBar from "../containers/AdaptiveMenuBar";

import Intro from "../containers/AnimatedIntro";
import About from "../components/About";
import WhatIDo from "../components/WhatIDo";
import Contact from "../components/Contact";
import Legal from "../components/Legal";

const Page = styled.div``;

export default () => (
  <Page>
    <AdaptiveMenuBar />
    <Intro />
    <About />
    <WhatIDo />
    <Contact />
    <Legal />
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/index.js